// extracted by mini-css-extract-plugin
module.exports = {"bg":"filter_bg__1_WDy","num":"filter_num__3XGks","checkboxes":"filter_checkboxes__1YBMF"};